import * as React from 'react'
interface Props {
    children?: React.ReactNode
    className?: string
    bottomContent?: React.ReactNode
}

const Footer: React.FC<Props> = ({ children, className, bottomContent }) => {
    const footerRef = React.useRef<HTMLDivElement>(null)
    const bufferRef = React.useRef<HTMLDivElement>(null)
    const prevHeightRef = React.useRef(0)
    const timing = 300

    React.useEffect(() => {
        const root = document.getElementById('root')
        const bottom = document.getElementById('bottom')
        if (!footerRef.current || !root) return

        const bufferDiv = document.createElement('div')
        bufferDiv.classList.add('buffer')
        bufferRef.current = bufferDiv

        if (bottomContent) {
            bottom.appendChild(bufferDiv)
        } else {
            root.appendChild(bufferDiv)
        }

        setTimeout(() => {
            if (!footerRef.current) return
            bufferRef.current.style.height = `${
                footerRef.current.getBoundingClientRect().height
            }px`
        }, timing)

        const observer = new MutationObserver(() => {
            setTimeout(() => {
                if (!footerRef.current) return
                const newHeight =
                    footerRef.current.getBoundingClientRect().height
                if (newHeight !== prevHeightRef.current) {
                    prevHeightRef.current = newHeight
                    if (bufferRef.current)
                        bufferRef.current.style.height = `${newHeight}px`
                }
            }, timing)
        })
        observer.observe(footerRef.current, {
            childList: true,
            subtree: true,
            characterData: true,
        })

        return () => {
            observer.disconnect()
            if (bottomContent) {
                const bufferDiv = bottom.querySelector('.buffer')
                if (bufferDiv) bottom.removeChild(bufferDiv)
            } else {
                const bufferDiv = root.querySelector('.buffer')
                if (bufferDiv) root.removeChild(bufferDiv)
            }
        }
    }, [])
    return (
        <>
            {bottomContent && <div id="bottom">{bottomContent}</div>}
            <div ref={footerRef} id="footer" className={className}>
                {children}
            </div>
        </>
    )
}
export default Footer
